import React from "react";
import PageHeader from "../../../components/reusable/management/PageHeader";

const FirmEarningsPage = () => {
    return (
        <>
            <PageHeader
                title="Firm Earnings"
                subtitle="Analyse revenue, profit and financial performance."
            />
        </>
    );
};

export default FirmEarningsPage;
